import type {ReactElement} from 'react'
import {faQuestionCircle} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {Link} from '@freckle/educator-materials/ts/components/link'
import {OverlayTrigger} from '@freckle/educator-materials/ts/components/overlay-trigger'
import {Popover} from '@freckle/educator-materials/ts/components/popover'
import {Text} from '@freckle/educator-materials/ts/components/typography'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'
import {iconStyle} from './fact-practice-level-tooltip.module.scss'

type Props = {
  tooltipPrefix?: string
  children?: ReactElement
  placement?: 'top' | 'right' | 'bottom' | 'left'
}

export function FactPracticeLevelTooltip(props: Props) {
  const {t} = useSafeTranslation()

  const supportUrl =
    'https://renaissance.widen.net/view/pdf/isu7zrzo5m/FreckleFactPracticeLevels.pdf?t.download=true&u-zceria'

  const tooltip = (
    <Popover id="fact-practice-level-tooltip">
      <Text style="subtitle-2">{props.children}</Text>
      <Text style="body-2">{props.tooltipPrefix}</Text>
      <Link target="_blank" rel="noopener" href={supportUrl} reactRouter={false}>
        {t('FACT_PRACTICE_LEVEL_LINK_SENTENCE_CASE')}
      </Link>
    </Popover>
  )

  return (
    <>
      {props.children}
      <OverlayTrigger trigger={['click']} placement={props.placement ?? 'top'} overlay={tooltip}>
        <FontAwesomeIcon icon={faQuestionCircle} size="1x" className={iconStyle} />
      </OverlayTrigger>
    </>
  )
}
